import { pageTypes, pageTypesLiteral as PageTypesLiteral } from '@/utils/constants';
import useMetaPageType from './useMetaPageType';
import useMetaContext from './useMetaContext';

export default function usePageType(aMetaObj) {
  const isBrowseRef = useState('pt-isBrowseRef', () => true);
  const isSplashRef = useState('pt-isSplashRef', () => false);
  const pageTypeRef = aMetaObj ? useMetaPageType(aMetaObj) : useMetaPageType();
  const contextRef = aMetaObj ? useMetaContext(aMetaObj) : useMetaContext();
  let sitePageType = '';
  let isSubSplash = false;
  let isSplash = false;
  let isBrowse = false;
  let isSearch = false;
  let isBrandIndex = false;
  let isBrandCategoryPage = false;
  let pageTypeLiteral = '';
  let isZeroSearchResults = false;
  let ispageTypeNotDefined = true;

  const pageType = pageTypeRef.value;
  const context = contextRef.value;
  const giftEligibleBrowsePage = pageType?.giftEligibleBrowsePage;

  /* istanbul ignore else */
  if (pageType?.subSplash || pageType?.brandPage) {
    sitePageType = pageTypes.SUBSPLASH;
    isSubSplash = true;
    isBrowseRef.value = true;
    pageTypeLiteral = PageTypesLiteral.subSplash;
    ispageTypeNotDefined = false;
  }
  /* istanbul ignore else */
  if (pageType?.search || pageType?.zeroSearchResults) {
    isZeroSearchResults = pageType?.zeroSearchResults ?? false;
    ispageTypeNotDefined = false;
    if (pageType?.giftEligibleBrowsePage) {
      sitePageType = pageTypes.BROWSE;
      isBrowse = true;
      isBrowseRef.value = true;
      pageTypeLiteral = PageTypesLiteral.browse;
    } else {
      sitePageType = pageTypes.SEARCH;
      isSearch = true;
      isBrowseRef.value = false;
      pageTypeLiteral = PageTypesLiteral.search;
    }
  }
  /* istanbul ignore else */
  if (pageType?.browse) {
    sitePageType = pageTypes.BROWSE;
    isBrowse = true;
    isBrowseRef.value = true;
    pageTypeLiteral = PageTypesLiteral.browse;
    ispageTypeNotDefined = false;
  }
  /* istanbul ignore else */
  if (pageType?.catSplash) {
    sitePageType = pageTypes.SPLASH;
    isSplash = true;
    isSplashRef.value = true;
    isBrowseRef.value = false;
    pageTypeLiteral = PageTypesLiteral.catSplash;
    ispageTypeNotDefined = false;
  }
  /* istanbul ignore else */
  if (pageType?.brandIndex) {
    sitePageType = pageTypes.BRANDINDEX;
    isBrandIndex = true;
    isSplashRef.value = true;
    isBrowseRef.value = false;
    pageTypeLiteral = PageTypesLiteral.brandIndex;
    ispageTypeNotDefined = false;
  }
  /* istanbul ignore else */
  if (pageType?.brandsCategoryPage) {
    sitePageType = pageTypes.BRANDSCATEGORYPAGE;
    isBrandCategoryPage = true;
    isSplashRef.value = true;
    isBrowseRef.value = false;
    pageTypeLiteral = PageTypesLiteral.brandsCategoryPage;
    ispageTypeNotDefined = false;
  }
  /* istanbul ignore else */
  if (ispageTypeNotDefined && context?.navigationType === 'BROWSE') {
    sitePageType = pageTypes.BROWSE;
    isBrowse = true;
    isBrowseRef.value = true;
    pageTypeLiteral = PageTypesLiteral.browse;
  }

  const searchWithinBrowseEnabled = pageTypeRef.value?.searchWithinBrowseEnabled;

  return {
    sitePageType,
    isSubSplash,
    // TODO replace isSplash and isBrowse by ref properties
    isSplash,
    isBrowse,
    isSearch,
    isBrandIndex,
    isBrandCategoryPage,
    pageTypeLiteral,
    isZeroSearchResults,
    giftEligibleBrowsePage,
    isBrowseRef,
    isSplashRef,
    searchWithinBrowseEnabled,
  };
}
